(function() {
    'use strict';

    angular
        .module('app.controllers.device.customDeviceOptions', [])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.entry.customDeviceOptions', {
                    abstract: true,
                    parent: 'device',
                    url: '/customDeviceOptions',
                    template: '<ui-view></ui-view>',
                    breadcrumb: {
                        ignore: true
                    }
                });
        }])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider
                .state('device.entry.customDeviceOptions.default', {
                    //parent: 'device.customDeviceOptions',
                    parent: 'device.entry.customDeviceOptions',
                    url: '/',
                    defaultParams: {
                        menuEntryId: '00000000-0000-0000-0000-000000000000'
                    },
                    templateUrl: 'views/CustomActions/customDeviceOptions.html',
                    controller: 'CustomDeviceOptionsCtrl',
                    controllerAs: 'vm',
                    breadcrumb: {
                        name: function() {
                            return 'NAV_CustomDeviceOptions';
                        }
                    }
                });
        }])
        .controller('CustomDeviceOptionsCtrl', CustomDeviceOptionsCtrl);

    /* @ngInject */
    function CustomDeviceOptionsCtrl(
        __MenuEntry,
        $translate,
        viewMenuBarService,
        actualDevice,
        f_Devices
    ) {
        var vm = this;

        var favoriteObject = {
            favoriteType: 'MenuEntry',
            favoriteObject: __MenuEntry.$buildRaw({
                "MenuEntryId": '8bb3f58d-43f8-4173-96b3-31551dc70f2d',
                "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                "DeviceId": actualDevice.DeviceId,
                'CustomActionName': 'DeviceOptions',
                'DisplayName': $translate.instant('NAV_CustomDeviceOptions'),
                'ImageName': 'techniker-settings'
            })
        };
        viewMenuBarService.setFavorite(favoriteObject);

        this.$onInit = () => {
            vm.dataDevice = angular.copy(actualDevice);
            vm.liveDevice = actualDevice;

            vm.deviceOptions = vm.dataDevice.DeviceOptions || [];
            vm.deviceOptions.forEach(function(option) {
                option.$UI = { buttons: false };
            });

            vm.possibleValues = {
                false: $translate.instant('False'),
                true: $translate.instant('True')
            };
        };

        vm.writeValue = (params) => {
            if (params.value !== params.params.IsActivated) {
                params.params.IsActivated = params.value;
                params.params.$UI.buttons = true;
            }
        };

        vm.writeValueByButton = (optionToSave) => {
            if (!vm.liveDevice.DeviceOptions) {
                return;
            }

            const newOptions = vm.liveDevice.DeviceOptions || [];

            for (let i = 0; i < newOptions.length; i++) {
                if (newOptions[i].OptionId === optionToSave.OptionId) {
                    newOptions[i].IsActivated = optionToSave.IsActivated;
                    f_Devices.addOrUpdateDevice(vm.liveDevice);
                    vm.liveDevice.$save();
                    optionToSave.$UI.buttons = false;
                    break;
                }
            }
        };

        vm.resetValueByButton = (optionToReset) => {
            const originalOptions = vm.liveDevice.DeviceOptions || [];

            for (let i = 0; i < vm.deviceOptions.length; i++) {
                if (optionToReset.OptionId === originalOptions[i].OptionId) {
                    optionToReset.IsActivated = originalOptions[i].IsActivated;
                    optionToReset.$UI.buttons = false;
                    break;
                }
            }
        };

    }
})();
